import { ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { DatasetsHeaderContainer } from '../../../modules/datasets/containers/DatasetHeader.container';
import { DatasetsListContainer } from '../../../modules/datasets/containers/DatasetsList.container';

export const DatasetsListView = (): ReactElement => (
  <DashboardContainer>
    <DatasetsHeaderContainer />
    <S_Card>
      <DatasetsListContainer />
    </S_Card>
  </DashboardContainer>
);
